import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useNavigate } from "react-router-dom";

const icon = (active) =>
  L.divIcon({
    className: "m2j-marker",
    html: `<div class="m2j-marker-pin" style="${active ? "transform:scale(1.25);background:#E0C173;" : ""}"></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -16],
  });

function FitBounds({ items }) {
  const map = useMap();
  useEffect(() => {
    if (!items || items.length === 0) return;
    const pts = items.filter((b) => b.lat && b.lng).map((b) => [b.lat, b.lng]);
    if (pts.length === 1) {
      map.setView(pts[0], 11);
    } else if (pts.length > 1) {
      map.fitBounds(pts, { padding: [50, 50] });
    }
  }, [items, map]);
  return null;
}

export default function BusinessMap({ items = [], activeId, onHover }) {
  const navigate = useNavigate();
  return (
    <MapContainer
      center={[46.6, 2.4]}
      zoom={5}
      scrollWheelZoom
      style={{ width: "100%", height: "100%", minHeight: "400px", zIndex: 0 }}
      data-testid="business-map"
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; OpenStreetMap contributors'
      />
      <FitBounds items={items} />
      {items.filter((b) => b.lat && b.lng).map((b) => (
        <Marker
          key={b.business_id}
          position={[b.lat, b.lng]}
          icon={icon(activeId === b.business_id)}
          eventHandlers={{
            mouseover: () => onHover && onHover(b.business_id),
            mouseout: () => onHover && onHover(null),
          }}
        >
          <Popup>
            <div style={{ minWidth: 180 }}>
              <img src={b.hero_image} alt={b.title} style={{ width: "100%", height: 90, objectFit: "cover" }} />
              <div style={{ fontWeight: 600, color: "#1B2A4A", marginTop: 6, fontFamily: "Playfair Display, serif" }}>{b.title}</div>
              <div style={{ fontSize: 12, color: "#475569" }}>{[b.city, b.region].filter(Boolean).join(", ")} · {b.sector}</div>
              <div style={{ fontSize: 13, color: "#1B2A4A", fontWeight: 600, marginTop: 2 }}>{b.profitability_rate != null ? `Rentabilité ${b.profitability_rate}%` : b.asking_price_range}</div>
              <button
                onClick={() => navigate(`/entreprise/${b.business_id}`)}
                style={{ marginTop: 8, background: "#E0C173", color: "#fff", border: "none", padding: "6px 12px", cursor: "pointer", fontSize: 12, width: "100%" }}
              >
                Voir la fiche
              </button>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
